function setActiveLook(item, expandedItem) {
  $(expandedItem).first().addClass('active');
  $(item).on('click', function () {
  const blockId = $(this).data('block-id');
  $(expandedItem).removeClass('active');
  $(`${expandedItem}[data-block-id="${blockId}"]`).addClass('active');
  });
}
$(document).ready(function () {
   const gridItem = '.lookbook-masonry-grid .grid-item';
   const expandItem = '.lookbook-page .lookbook-expanded';
   setActiveLook(gridItem, expandItem);

  let activeBlockId = null;
  
  function activateFirstLookbookMobile() {
    if ($(window).width() < 1023) {
      activeBlockId = $('.mobile-lookbook-expanded').first().data('block-id');
      $('.mobile-lookbook-expanded').removeClass('active');
      $(`.mobile-lookbook-expanded[data-block-id="${activeBlockId}"]`).addClass('active');
    }
  }
  
  activateFirstLookbookMobile();

  $('.grid-item').on('click', function () {
    const blockId = $(this).data('block-id');
    activeBlockId = blockId;
    $('.mobile-lookbook-expanded').removeClass('active');
    const targetLookbook = $(`.mobile-lookbook-expanded[data-block-id="${blockId}"]`);
    targetLookbook.addClass('active');
    $('html, body').animate({
      scrollTop: targetLookbook.offset().top
    }, 800);
  });
  
  $(window).on('scroll', function () {
    if (activeBlockId) {
      $(`.mobile-lookbook-expanded[data-block-id="${activeBlockId}"]`).addClass('active');
    }
  });
  
  $(window).on('resize', function() {
    if ($(window).width() >= 1023) {
      $('.page-odd .lookbook-expanded').first().addClass('active');
    }
    activateFirstLookbookMobile();
  });
  
  // if ($('.masonry-grid').length > 0) {

  //   var owl = $('.owl-carousel').owlCarousel({
  //     loop: false,
  //     items: 1,
  //     nav: true,
  //     dots: false,
  //     lazyLoad: true,
  //      navText: [
  //       '<svg xmlns="http://www.w3.org/2000/svg" width="27.001" height="15.753" viewBox="0 0 27.001 15.753"><g id="arrow-left" transform="translate(-4.499 -10.124)"><path id="Path_15" data-name="Path 15" d="M13.171,10.454a1.125,1.125,0,0,1,0,1.593L7.216,18l5.956,5.954a1.126,1.126,0,0,1-1.593,1.593L4.829,18.8a1.125,1.125,0,0,1,0-1.593l6.75-6.75a1.125,1.125,0,0,1,1.593,0Z" fill="#fff" fill-rule="evenodd"/><path id="Path_16" data-name="Path 16" d="M5.625,18A1.125,1.125,0,0,1,6.75,16.875H30.375a1.125,1.125,0,0,1,0,2.25H6.75A1.125,1.125,0,0,1,5.625,18Z" fill="#fff" fill-rule="evenodd"/></g></svg>',
  //       '<svg id="arrow-left" xmlns="http://www.w3.org/2000/svg" width="27.002" height="15.753" viewBox="0 0 27.002 15.753"><path id="Path_15" data-name="Path 15" d="M4.829,10.454a1.125,1.125,0,0,0,0,1.593L10.785,18,4.828,23.954a1.126,1.126,0,0,0,1.593,1.593l6.75-6.75a1.125,1.125,0,0,0,0-1.593l-6.75-6.75a1.125,1.125,0,0,0-1.593,0Z" transform="translate(13.5 -10.123)" fill="#fff" fill-rule="evenodd"/><path id="Path_16" data-name="Path 16" d="M31.5,18a1.125,1.125,0,0,0-1.125-1.125H6.75a1.125,1.125,0,1,0,0,2.25H30.375A1.125,1.125,0,0,0,31.5,18Z" transform="translate(-5.625 -10.123)" fill="#fff" fill-rule="evenodd"/></svg>'
  //     ]
  //   });

  //   $('.grid-item img').on('click', function () {
  //     var blockId = $(this).parent().data('block-id');
  //     if (!blockId) return;

  //     var slideIndex = findCarouselSlideIndex(blockId);

  //     if (slideIndex !== -1) {
  //       owl.trigger('to.owl.carousel', [slideIndex, 300]);
  //       $('#carousel-overlay').fadeIn();
  //     }
  //   });

  //   function findCarouselSlideIndex(blockId) {
  //     var $carouselItems = $('.owl-carousel .item');
  //     for (var i = 0; i < $carouselItems.length; i++) {
  //       if ($carouselItems.eq(i).data('block-id') == blockId) {
  //         return i;
  //       }
  //     }
  //     return -1;
  //   }

  //   $('#carousel-overlay').on('click', function (e) {
  //     if (e.target.id === 'carousel-overlay') {
  //       $('#carousel-overlay').fadeOut();
  //     }
  //   });

  //   $('.exit-modal').on('click', function () {
  //     $('#carousel-overlay').fadeOut();
  //   });

  //   $('.close-carousel').on('click', function () {
  //     $('#carousel-overlay').fadeOut();
  //   });
  // }
});
